import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
// import { environment } from './environment';

import { Observable } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';

import { Account } from './account';

@Injectable({
   providedIn: 'root'
})
export class AccountService {
   error: string;

   get account(): Account {
      const a = sessionStorage.getItem( 'accountInfo' );
      if ( !a ) { return; }

      return new Account( JSON.parse( a ));
   }
   set account( value ) {
      sessionStorage.setItem( 'accountInfo', JSON.stringify( value ));
      if ( !value ) { sessionStorage.removeItem( 'accountInfo' ); }
   }

   get number() { return sessionStorage.getItem( 'account' ) ? +sessionStorage.getItem( 'account' ) : null; }
   set number( value ) { sessionStorage.setItem( 'account', value?.toString() ); }

   get pin() { return sessionStorage.getItem( 'pin' ) ? +sessionStorage.getItem( 'pin' ) : null; }
   set pin( value ) { sessionStorage.setItem( 'pin', value?.toString() ); }

   constructor(
      private http: HttpClient,
   ) { }

   verifyAccount(): Observable<Account> {
      this.account = null;
      this.error = null;

      return this.http.post( 'account', { account: this.number, pin: this.pin })
         .pipe(
            map( a => new Account({ ...a, number: this.number })),
            tap( account => this.account = account ),
            catchError( err => {
               this.error = err?.error?.status?.message ?? 'This system is unavailable at this time, please try again later';

               throw err;
            }),
         );
   }

   reset() {
      sessionStorage.clear();
   }
}
